import { InfoLabel } from 'bold-ui'
import { SemanasDiasFieldModel } from 'components/form/field/SemanasDiasField'
import React from 'react'
import { isUndefinedOrNull } from 'util/checks'
import { formatDate } from 'util/date/formatDate'

import { ResultadoEspecificoPrenatal } from '../../model-resultadosExames'

interface ResultadoExamePrenatalViewProps {
  value: ResultadoEspecificoPrenatal
}

export const ResultadoExamePrenatalView = (props: ResultadoExamePrenatalViewProps) => {
  const { value } = props

  return <InfoLabel title='Resultado'>{mountIdadeGestacionalValue(value)}</InfoLabel>
}

export const mountIdadeGestacionalValue = ({
  dpp,
  idadeGestacional,
}: {
  dpp: LocalDate
  idadeGestacional: SemanasDiasFieldModel
}): string => {
  let { semanas, dias } = idadeGestacional || {}

  let hasSemanas = !isUndefinedOrNull(semanas)
  let hasDias = !isUndefinedOrNull(dias)

  if (typeof semanas === 'string') {
    try {
      semanas = Number.parseInt(semanas)
    } catch {
      hasSemanas = false
    }
  }

  if (typeof dias === 'string') {
    try {
      dias = dias === '' ? 0 : Number.parseInt(dias)
    } catch {
      hasDias = false
    }
  }

  const separator = dpp && hasSemanas ? ' - ' : ''
  const diasFormatted = hasDias ? `e ${'dia'.pluralizeAndConcatValue(dias)}` : 'e 0 dia'
  const semanasAndDiasFormatted = hasSemanas
    ? `Idade gestacional eco ${'semana'.pluralizeAndConcatValue(semanas)} ${diasFormatted}`
    : ''
  const ddpFormatted = dpp ? `DPP eco ${formatDate(dpp)}` : ''

  return `${semanasAndDiasFormatted}${separator}${ddpFormatted}`
}
